module.exports = __webpack_public_path__ + "img/logo_detak.co.7e6b4f43.png";